import { Box } from "@chakra-ui/react";

export function JournalistIcon({ width, height, ...props }: any) {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
      >
        <path
          d="M16.7314 16.334H17.1808C18.2348 16.334 19.0732 15.8537 19.8259 15.1822C21.7382 13.4764 17.2429 11.7507 15.7083 11.7507M13.875 2.64702C14.0831 2.60574 14.2993 2.58398 14.521 2.58398C16.1893 2.58398 17.5417 3.8152 17.5417 5.33398C17.5417 6.85277 16.1893 8.08398 14.521 8.08398C14.2993 8.08398 14.0831 8.06223 13.875 8.02095"
          stroke="#CBE957"
          strokeWidth="1.375"
          strokeLinecap="round"
        />
        <path
          d="M3.77456 12.7692C2.69383 13.3484 -0.139771 14.531 1.58608 16.0108C2.42915 16.7337 3.3681 17.2507 4.5486 17.2507H11.2848C12.4653 17.2507 13.4042 16.7337 14.2473 16.0108C15.9731 14.531 13.1395 13.3484 12.0588 12.7692C9.52453 11.4111 6.30884 11.4111 3.77456 12.7692Z"
          stroke="#CBE957"
          strokeWidth="1.375"
        />
        <path
          d="M11.5834 4.87565C11.5834 6.9007 9.94173 8.54232 7.91669 8.54232C5.89164 8.54232 4.25002 6.9007 4.25002 4.87565C4.25002 2.85061 5.89164 1.20898 7.91669 1.20898C9.94173 1.20898 11.5834 2.85061 11.5834 4.87565Z"
          stroke="#CBE957"
          strokeWidth="1.375"
        />
      </svg>
    </Box>
  );
}
